import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as ga from '../../redux/actions/app';

import {
  GET_COLUMN_DATA,
  GET_INVESTIGATION_DATA,
  GET_STATUS_COUNT,
  getColumnDataSuccess,
  getInvestigationDataFail,
  getInvestigationDataSuccess,
  getStatusCountSuccess
} from '../../redux/actions/tm/investigation';

import {
  getColumnData,
  getInvestigationData,
  getStatusCount
} from '../../services/tm/investigation';

function* getStatusCountWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getStatusCount, payload);
    yield put(getStatusCountSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
  }
}

function* getColumnDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getColumnData, payload);
    yield put(getColumnDataSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
  }
}

function* getInvestigationDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getInvestigationData, payload);

    yield put(getInvestigationDataSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getInvestigationDataFail({ error }));
  }
}

export function* watchGetStatusCount() {
  yield takeEvery(GET_STATUS_COUNT, function* ({ payload }) {
    yield fork(getStatusCountWorker, payload);
  });
}

export function* watchGetColumnData() {
  yield takeEvery(GET_COLUMN_DATA, function* ({ payload }) {
    yield fork(getColumnDataWorker, payload);
  });
}

export function* watchGetInvestigationData() {
  yield takeEvery(GET_INVESTIGATION_DATA, function* ({ payload }) {
    yield fork(getInvestigationDataWorker, payload);
  });
}
